import { a as getAugmentedNamespace, c as commonjsGlobal } from './_commonjsHelpers-BlEkfD1Z.js';
import { _ as _polyfillNode_process } from './_polyfill-node.process-xadMkScK.js';

var useAssert$1 = {};

var require$$0 = /*@__PURE__*/getAugmentedNamespace(_polyfillNode_process);

var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(useAssert$1, "__esModule", { value: true });
var useAssert_2 = useAssert$1.useAssert = void 0;
const process_1 = __importDefault(require$$0);
function useAssert(shouldShow, message, options) {
    var _a;
    if (((_a = process_1.default === null || process_1.default === void 0 ? void 0 : process_1.default.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) !== "production" && shouldShow) {
        if (options === null || options === void 0 ? void 0 : options.warn) {
            console.warn(message);
        }
        else {
            throw new Error(message);
        }
    }
}
useAssert_2 = useAssert$1.useAssert = useAssert;

export { useAssert_2 as u };
